import { combineReducers } from 'redux';

import * as user from './user';
import pros from './pros';
import calls from './calls';
import userDetails from './userDetails';
import url from './url';
import chat, { moduleName as chatModule } from './chat';
import * as wallet from './wallet';
import sectors from './sectors';
import featuredService from './featuredService';
import * as files from './files';
import notifications from './api-notifications';
import applicationReducer, { moduleName as applicationModule } from './application';
import categoriesReducer, { moduleName as categoriesModule } from './categories';
import countriesReducer, { moduleName as countriesModule } from './countries';
import findPro from './findPro';
import forgotPasswordReducer, { moduleName as forgotPasswordModule } from './forgotPassword';
import messageReducer, { moduleName as messageModule } from './message';
import signInReducer, { moduleName as signInModule } from './sign-in';
import signUpReducer, { moduleName as signUpModule } from './sign-up';
import tokenValidation from './tokenValidation';
import bookings, { moduleName as bookingsModule } from './bookings';
import callTimer, { moduleName as callTimerModule } from './callTimer';

const rootReducer = combineReducers({
  [applicationModule]: applicationReducer,
  [categoriesModule]: categoriesReducer,
  [countriesModule]: countriesReducer,
  findPro,
  [forgotPasswordModule]: forgotPasswordReducer,
  [messageModule]: messageReducer,
  loggedInUser: user.loggedInUser,
  logInFailure: user.logInError,
  availability: user.availability,
  /* loggedInUserProCalls: user.proCalls,
  loggedInUserPersonalCalls: user.personalCalls, */
  loggedInUserActivity: user.activity,
  loggedInUserTransactions: user.transactions,
  registerSuccess: user.registerSuccess,
  registerFailureMessage: user.registerFailureMessage,
  verifySuccess: user.verifySuccess,
  verifyFailure: user.verifyFailure,
  resetSuccess: user.resetSuccess,
  resetFailure: user.resetFailure,
  pendingActivation: user.pendingActivation,
  sendCodeSuccess: user.sendCodeSuccess,
  sendCodeFailureMessage: user.sendCodeFailureMessage,
  verifyCodeSuccess: user.verifyCodeSuccess,
  verifyCodeFailureMessage: user.verifyCodeFailureMessage,
  dataFromServer: user.dataFromServer,
  sendContactMessage: user.sendContactMessage,
  locale: user.locale,
  branchIo: user.branchIo,
  [chatModule]: chat,
  creditCards: wallet.creditCards,
  bankAccounts: wallet.bankAccount,
  stripeToken: wallet.stripeToken,
  topUpInfo: wallet.topUpInfo,
  widthdrawInfo: wallet.widthdrawInfo,
  pros,
  calls,
  userDetails,
  url,
  sectors,
  globalMessage: user.globalMessage,
  badges: user.badges,
  featuredService,
  files: files.uploadFiles,
  redirect: user.redirect,
  notifications,
  [signInModule]: signInReducer,
  [signUpModule]: signUpReducer,
  tokenValidation,
  [bookingsModule]: bookings,
  [callTimerModule]: callTimer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js